export const toHex = (n: number, minlen: number) => {
  let s = n.toString(16).toUpperCase();
  while (s.length < minlen) {
    s = `0${s}`;
  }

  return s;
};

export const digitSum = (n: number) => {
  let q = 0;
  while (n !== 0) {
    q += n % 10;
    n = Math.floor(n / 10);
  }

  return q;
};

export const getPayloadFromChipTanCode = (chipTanCode: string) => {
  let i = 0;
  let payload = '';

  let len = parseInt(chipTanCode.slice(0, 2), 16);
  i += 2;
  while (i < chipTanCode.length - 2) {
    i += 1;
    len = parseInt(chipTanCode.slice(i, i + 1), 16);
    i += 1;
    payload += chipTanCode.slice(i, i + len * 2);
    i += len * 2;
  }

  return payload;
};

export const checkSumChipTanCode = (chipTanCode: string) => {
  // Here we calculate the checksum of the chipTan code.
  // For more information on how the ChipTan code is formatted, see:
  // https://github.com/basimhennawi/react-chiptan/blob/master/Code.md
  let code = chipTanCode.toUpperCase().replace(/[^a-fA-F0-9]/g, '');

  const len = code.length / 2 - 1;
  code = toHex(len, 2) + code.substring(2);

  const luhndata = getPayloadFromChipTanCode(code);
  let luhnsum = 0;
  for (let i = 0; i < luhndata.length; i += 2) {
    luhnsum += 1 * parseInt(luhndata[i], 16) + digitSum(2 * parseInt(luhndata[i + 1], 16));
  }
  luhnsum = (10 - (luhnsum % 10)) % 10;
  code = code.substring(0, code.length - 2) + toHex(luhnsum, 1) + code.substring(code.length - 1);

  let xorsum = 0;
  for (let i = 0; i < code.length - 2; i++) {
    // eslint-disable-next-line no-bitwise
    xorsum ^= parseInt(code[i], 16);
  }

  return code.substring(0, code.length - 1) + toHex(xorsum, 1);
};
